<template>
  <iframe style="width:100%; height:100vh" src="https://icra.muraciet.az/main" frameborder="0"></iframe>
</template>

<script>
export default {

}
</script>

<style>

</style>